import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/approval-rules')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./approval-rules.lazy').then((d) => d.Route));
